import CarSvg from "./images/ic_car_block.svg";
import TruckSvg from "./images/ic_truck_block.svg";
import ScooterSvg from "./images/ic_scooter_block.svg";
import RickshawSvg from "./images/ic_rickshaw_block.svg";
import CycleSvg from "./images/ic_cycle_block.svg";
import BusSvg from "./images/ic_bus_block.svg";
import TempoSvg from "./images/ic_tempo_block.svg";
import MiniTempoSvg from "./images/ic_mini_tempo_block.svg";
import ContainerSvg from "./images/ic_container_block.svg";
import AllVehiclesSvg from "./images/ic_parking.svg"
import FASTagImg from './images/fastag_device.png'
import POSImg from './images/pos.png'
import ANPRImg from './images/anpr.png'
import PASSImg from './images/pass_img.png'
import FOCImg from './images/foc_img.png'
import DROPOFFImg from './images/drop_off_img.png'
import MANUALImg from './images/mannual_img.png'
import PRIVATEImg from './images/private_img.png'
import COMMERCIALImg from './images/commerical_img.png'
import PAIDImg from './images/paid_img.png'
import ISSUEImg from './images/issue_img.png'
import RECHARGEImg from './images/recharge_img.png'
import FREEPASSImg from './images/free_pass.png'
import PAIDPASSImg from './images/paid_pass_img.png'
import VISITORSImg from './images/visitors_img.png'
import HELMETImg from './images/helmet.png'
import CARS24Img from './images/cars_24_img.png'
import HIPPOSTORESImg from './images/hippo_stores_img.png'
import VIPULMOTORSImg from './images/vipul_motors_img.png'
import OTHERSImg from './images/Others_Img.png'
import notify from "./components/CustomUseNotify";
import config from './config.json';
export const passwordSalt = "abcdefghijkl";

export const vehicleSvgs = {
    "All": AllVehiclesSvg,
    "2": ScooterSvg,
    "3": RickshawSvg,
    "4": CarSvg,
    "5": CycleSvg,
    "6": BusSvg,
    "7": TruckSvg,
    "8": TempoSvg,
    "9": MiniTempoSvg,
    "10": ContainerSvg,
    "11": HELMETImg
}

export const AnalyticDistributionImgs = {
    "CASH": {label: "CASH", img: PAIDImg},
    "FASTag": {label: "FASTag", img: FASTagImg},
    "ANPR": {label: "ANPR", img: ANPRImg},
    "POS": {label: "POS", img: POSImg},
    "Yet to Exit": {label:"Yet to Exit", img: FASTagImg},
    "MANUAL": {label:"MANUAL", img: POSImg},
    "VIOLATIONS": {label:"VIOLATIONS", img: ANPRImg},
    "Violations": {label:"Violations", img: ANPRImg},
    "Future Exits": {label:"Future Exits", img: ANPRImg},
    "ANPR+POS": {label:"ANPR+POS", img: ANPRImg},
    "ISSUE": {label:"Issue", img: ISSUEImg},
    "RECHARGE": {label:"Recharge", img: RECHARGEImg},
    "PAID": {label:"Paid", img: PAIDImg},
    "DROP OFF": {label:"Drop Off", img: DROPOFFImg},
    "Private": {label:"Private", img:PRIVATEImg},
    "Manual": {label:"Manual", img: MANUALImg},
    "Commercial": {label:"Commercial", img:COMMERCIALImg},
    "PASS": {label:"Pass", img:PASSImg},
    "DIGITAL PAYMENTS": {label:"Digital Payments", img:PAIDImg},
    "ONLINE": {label:"Online", img:PAIDImg},
    "UNPAID": {label:"Unpaid", img:PAIDImg},
    "UPI": {label: "UPI", img: FASTagImg},
    "FOC": {label:"Foc", img:FOCImg},
    "FREE PASS": {label:"Free Pass", img:FREEPASSImg},
    "Paid": {label:"Paid", img: PAIDImg},
    "Permit Pass": {label:"Permit Pass", img:FREEPASSImg},
    "Monthly Pass": {label:"Monthly Pass", img:PAIDPASSImg},
    "Drop Off": {label:"Drop Off", img: DROPOFFImg},
    "Visitors": {label:"Visitors", img: VISITORSImg},
    "Cars 24": {label:"Cars 24", img: CARS24Img},
    "Vipul Motors": {label:"Vipul Motors", img: VIPULMOTORSImg},
    "Hippo": {label: "Hippo Stores", img: HIPPOSTORESImg}, 
    "Others": {label: "Others", img: OTHERSImg}, 
    "2": {label:"Bike", img: ScooterSvg},
    "3": {label:"Rickshaw", img: RickshawSvg},
    "4": {label:"Car", img: CarSvg},
    "5": {label:"Cycle", img: CycleSvg},
    "6": {label:"Bus", img: BusSvg},
    "7": {label:"Truck", img: TruckSvg},
    "8": {label:"Tempo", img: TempoSvg},
    "9": {label:"Mini Tempo", img: MiniTempoSvg},
    "10": {label:"Container", img: ContainerSvg},
    "11": {label:"Helmet", img: HELMETImg },
    "12": {label:"Supplies", img: TruckSvg },
    "Advance": {label:"Advance", img: FASTagImg},
    "On Site": {label:"On Site", img:ANPRImg},
    "Cash": {label:"Cash", img: PAIDImg},
    "Up Count": {label:"Up Count", img: FASTagImg},
    "Down Count": {label:"Down Count", img: FASTagImg},
}

export const sampleReceiptText = {
    text: "",
    size: 2,
    bold: false,
    underline: false,
    alignment: "CENTER",
    grayscale: 1,
    entry: true,
    exit: true,
    all_vehicles: true,
    Scooter: true,
    Auto: true,
    Car: true,
    Cycle: true,
    Bus: true,
    Truck: true,
    Tempo: true,
    "Mini-Tempo": true,
    Container: true,
    Helmet: true
}

export const parkingConfigurationProperties = {
    "advance_payment_enabled": false,
    "allow_entry_exit_after_monthly_pass_expiry": false,
    "allow_exit_without_print": true,
    "allow_free_vehicle_at_exit": false,
    "allow_payments_without_mobile_number": false,
    "allow_qr_payments_by_razorpay": false,
    "allow_qr_payments_by_phonepe": false,
    "allow_remarks": false,
    "allow_summary": true,
    "allow_time_in_custom_summary": false,
    "boom_barrier_from_timewatch": false,
    "current_vehicle_expiry": 32,
    "current_vehicle_expiry_hour": 0,
    "current_vehicle_expiry_minute": 0,
    "default_vehicle_prefix": "",
    "dynamic_summary_password": false,
    "helmet": {
        "periodic_cost": 5,
        "periodic_cost_max": 10,
        "periodic_delay": "00:00:00",
        "periodic_duration": "12:00:00"
    },
    "hide_current_vehicles_count": false,
    "hide_amounts_in_summary": false,
    "hide_reprint_button": false,
    "hide_today_entry": false,
    "is_gates_feature_enabled": false,
    "show_billing_qr": true,
    "is_monthly_pass_qr_enabled": false,
    "monthly_pass_recharge_enabled": false,
    "lost_ticket_cost": {
        "Auto": 0,
        "Bus": 0,
        "Car": 0,
        "Cycle": 0,
        "Scooter": 0,
        "Truck": 0,
        "Tempo": 0,
        "Mini-Tempo": 0,
        "Container": 0
    },
    "lost_ticket_enabled": false,
    "max_list_size": 500,
    "minimum_advance_duration": 0,
    "pass_value_workaround": false,
    "password_on_summary": "",
    "patrolling_enabled": false,
    "shifts_enabled": false,
    "show_currently_parked_vehicles_menu": false,
    "show_not_exited_vehicle_menu": false,
    "show_prefix": false,
    "show_mobile_number": true,
    "show_seconds_on_receipt": false,
    "vehicle_entry_timeout": 600,
    "vehicle_image_at_entry": false,
    "vehicle_image_at_entry_is_compulsory": false,
    "violations": [
        {
            "name": "",
            "factor": 1
        },
    ],
    "violation_enabled": false,
    "work_manager_retry_duration": 5000,
    "allow_entry_by_fastag": false,
    "complete_vehicle_number_as_input": false,
    "allow_logout_while_syncing": false,
    "booking_enabled": false,
    "allow_payments_by_wallet": false,
    "offline_qr_code_enabled": false,
    "unpaid_option_at_exit": false,
    "hide_vehicle_details": false,
    "show_exit_filters": false,
    "zones": {
        "enabled": false,
        "zone_names": [],
    },
    "public_holidays":
    {
        "enabled": false,
        "holidays": []
    },
    "custom_remarks":
    {
        "enabled": false,
        "remarks":[]
    },
    "to_print_remark": false,
    "allow_manual_entry_at_nfc": false,
    "receipt_printing_allowed_at_nfc": false,
    "departments":
    {
        "enabled": false,
        "names":[]
    },
    "static_qr_code_url": "",
    "enter_vehicle_details_at_exit": false,
    "allow_custom_summary": true,
    "parking_spots":
    {
        "enabled": false,
        "spots":[]
    },
    "show_customer_name": false,
    "upload_entry_pos_image": false,
    "rc_required": false,
    "allow_barcode_scan_in_sunmi": false,
    "edit_vehicle_details_at_exit": false,
    "allow_anpr_image_from_pos": false,
    "show_sync_warning": false,
    "fill_company_name_in_monthly_pass": false,
    "generate_qr_manually": "",
    "is_remark_compulsory_on_foc": false,
    "online_payments_enabled": false,
    "print_monthly_pass_summary": false
}

export const parkingReceiptProperties = {
    "is_qr_code_enabled": false,
    "is_bar_code_enabled": false,
    "print_device_id": false,
    "gmp_copy": false,
    "print_unique_user_id": false,
    "print_ticket_number": false,
    "vehicle_number_size": 5,
    "amount_size": 4,
    "duration_size": 4,
    "entry_date_size": 3,
    "is_entry_date_bold": false,
    "entry_time_size": 4,
    "exit_date_size": 3,
    "exit_time_size": 3,
    "free_parking_text": "",
    "print_summary_device_id": false,
    "print_big_qr": false,
    "show_amount": true,
    "show_vehicle_number": true,
    "print_fastag_receipts": false,
    "automatic_fastag_receipt_print": false,
    "automatic_exit_fastag_receipts": false,
    "automatic_entry_fastag_receipts": false,
    "show_mobile_number_on_monthly_pass": false,
    "show_only_validity": false,
    "name_size": 1,
    "qr_size": 0,
}

export const fastagIssuers = {
    "607569": "Airtel",
    "608087": "AU Small Finance Bank", //
    "607529": "Axis Bank",
    "652151": "Bank of Baroda",
    "607003": "Central Bank of India", //
    "607949": "City Union Bank",
    "652402": "Equitas",
    "607318": "HDFC Bank",
    "607802": "HDFC Bank",
    "607417": "ICICI Bank",
    "607095": "IDBI Bank",
    "608116": "IDFC First Bank",
    "222222": "IHMCL",
    "222223": "IHMCL",
    "607016": "Indian Bank",
    "607170": "Indian Overseas Bank", //
    "608266": "IndusInd Bank",
    "607189": "IndusInd Bank",
    "607134": "Jalgaon People's Co-op Bank", //
    "607100": "Karur Vysya Bank",
    "607421": "Kotak Mahindra Bank",
    "607469": "Kotak Mahindra Bank",
    "607720": "PayTM",
    "608032": "PayTM",
    "607859": "Punjab National Bank",
    "652150": "Saraswat Bank",
    "652203": "South Indian Bank", //
    "606986": "State Bank of India",
    "607916": "Thrissur District Co-op Bank", //
    "606992": "Union Bank of India",
    "652210": "Yes Bank",
    "607363": "Federal Bank",
    "608268": "Federal Bank"
};

export const paymentModeColors = {
    "CASH": "#e99100",
    "WALLET": "#16cc69",
    "CARD": "#109cf1",
    "UPI": "#885af8",
    "FASTag": "#18cc69",
    "UNPAID": "#888888",
    "FASTag + CASH": "#e99100"
};

export const hideVehicleNumber = (vehicleNumber) => {
    if(sessionStorage.getItem("demo_access") === "1") return `${isNaN(vehicleNumber.charAt(0)) ? vehicleNumber.slice(0, 2) + vehicleNumber.slice(2, vehicleNumber.length - 4).replace(/./g, '*') : ''}${vehicleNumber.slice(-4)}`
    return vehicleNumber
}
export const hideMobileNumber = (mobileNumber, privacyFeatureAccess = false) => {
    if(privacyFeatureAccess) return mobileNumber
    if(sessionStorage.getItem("demo_access") === "1" || sessionStorage.getItem("hide_mobile_number") === "1") return `${mobileNumber.slice(0, mobileNumber.length - 4).replace(/./g, '*')}${mobileNumber.slice(-4)}`
    return mobileNumber
}
export const hideName = (name) => {
    if(sessionStorage.getItem("demo_access") === "1") return `${name.slice(0, name.length - 2).replace(/./g, '*')}${name.slice(-4)}`
     return name
}


export const getTutorials = () => (
    {
        "/permitLogs" : {
            steps : [ 
                {
                    title: "Vehicle Summary",
                content: 'In this section you can check all the Vehicle Summary.',
                targetClass: 'society_step-12',
                visible: (sessionStorage.getItem('vehicle_summary_name') === "Visitor Summary" ||  sessionStorage.getItem('vehicle_summary_name') ==="Dashboard")
                },
                {
                title: "Logs",
                content: 'Displays logs of all vehicles with permits for the site',
                targetClass: 'society_step-1',
                visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_logs') === "1" 
            },
            {
                title: "Logs",
                content: 'Displays logs of all vehicles with permits for the site',
                targetClass: 'society_step-17',
                visible: sessionStorage.getItem("show_monthly_pass") === "1"
            },
            {
                title: "Permit Users",
            content: 'Lists all users with active or inactive permits.',
            targetClass: 'society_step-2',
            visible: sessionStorage.getItem('show_rfid') === "1"
            },
            {
                title: "Users",
            content: 'Lists all users with active or inactive permits.',
            targetClass: 'society_step-19',
            visible: sessionStorage.getItem("show_monthly_pass") === "1"
            },
            {
                title: "Permit Requests",
            content: 'Lists users requesting a permit.',
            targetClass: 'society_step-3',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_requests') === "1"
            },
            {
                title: "Company Users",
            content: 'Lists companies at the site and provides an option to add new companies.',
            targetClass: 'society_step-4',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem("show_rfid_company") === "1"
            },
            {
                title: "Apartments",
            content: 'Lists apartments at the site and the number of vehicles associated with each apartment.',
            targetClass: 'society_step-5',
            visible : sessionStorage.getItem('show_permit_apartments') === "1"
            },
            {
                title: "Inventory",
            content: 'Lists ParkSmart tags allocated to the site.',
            targetClass: 'society_step-6',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_inventory') === "1"
            },
            {
                title: "Deleted",
            content: 'Lists deleted users and provides an option to restore them.',
            targetClass: 'society_step-7',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_deleted_details') === "1"
            },
            {
                title: "Payments",
            content: 'Logs all payments made for permits.',
            targetClass: 'society_step-8',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_payments') === "1"
            },
            {
                title: "Payments",
            content: 'Logs all payments made for permits.',
            targetClass: 'society_step-18',
            visible: sessionStorage.getItem("show_monthly_pass") === "1"
            },
            {
                title: "Surveillance Logs",
            content: 'Logs of users without permits, including their entry and exit images',
            targetClass: 'society_step-9',
            visible: sessionStorage.getItem('show_visitor_logs') === "1"
            },
            {
                title: "Controllers",
            content: 'Displays all installed controllers at the site, serving as the system brain, indicating their internet connectivity status.',
            targetClass: 'society_step-10',
            visible: sessionStorage.getItem('show_parking_controllers') === "1"
            },
            
            {
                title: "Currently Parked",
            content: 'In this section you can check all the Currently Parked Vehicles.',
            targetClass: 'society_step-16',
            visible: sessionStorage.getItem('show_currently_parked') === "1"
            },
            {
                title: "Reports",
            content: 'Allows the creation of custom reports with the option to schedule them for daily, weekly, or monthly email delivery.',
            targetClass: 'society_step-15',
            visible: sessionStorage.getItem('show_reports') === "1"
            },
            {
                title: "Resources",
            content: 'Encompasses all ParkSmart-provided resources, from user app installation to onboarding vehicles.',
            targetClass: 'society_step-11',
            visible: true
            },
            
            {
                title: "Occupancy",
            content: 'Displays floor-wise vehicle entry, exit, and overall floor occupancy.',
            targetClass: 'society_step-13',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_floor_occupancy') === "1"
            },
            
            ]
        },

        "/parkings" : {
            steps : [ 
                {
                    title: "Vehicle Summary",
                content: 'In this section you can check all the Vehicle Summary.',
                targetClass: 'society_step-12',
                visible: (sessionStorage.getItem('vehicle_summary_name') === "Visitor Summary" ||  sessionStorage.getItem('vehicle_summary_name') ==="Dashboard")
                },
                {
                title: "Logs",
                content: 'Displays logs of all vehicles with permits for the site',
                targetClass: 'society_step-1',
                visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_logs') === "1" 
            },
            {
                title: "Monthly Pass Logs",
                content: 'Displays logs of all vehicles with permits for the site',
                targetClass: 'society_step-17',
                visible: sessionStorage.getItem("show_monthly_pass") === "1"
            },
            {
                title: "Permit Users",
            content: 'Lists all users with active or inactive permits.',
            targetClass: 'society_step-2',
            visible: sessionStorage.getItem('show_rfid') === "1"
            },
            
            {
                title: "Payments",
            content: 'Logs all payments made for permits.',
            targetClass: 'society_step-18',
            visible: sessionStorage.getItem("show_monthly_pass") === "1"
            },
            {
                title: "Users",
            content: 'Lists all users with active or inactive permits.',
            targetClass: 'society_step-19',
            visible: sessionStorage.getItem("show_monthly_pass") === "1"
            },
            {
                title: "Permit Requests",
            content: 'Lists users requesting a permit.',
            targetClass: 'society_step-3',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_requests') === "1"
            },
            {
                title: "Company Users",
            content: 'Lists companies at the site and provides an option to add new companies.',
            targetClass: 'society_step-4',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem("show_rfid_company") === "1"
            },
            {
                title: "Apartments",
            content: 'Lists apartments at the site and the number of vehicles associated with each apartment.',
            targetClass: 'society_step-5',
            visible : sessionStorage.getItem('show_permit_apartments') === "1"
            },
            {
                title: "Inventory",
            content: 'Lists ParkSmart tags allocated to the site.',
            targetClass: 'society_step-6',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_inventory') === "1"
            },
            {
                title: "Deleted",
            content: 'Lists deleted users and provides an option to restore them.',
            targetClass: 'society_step-7',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_deleted_details') === "1"
            },
            {
                title: "Payments",
            content: 'Logs all payments made for permits.',
            targetClass: 'society_step-8',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_rfid_payments') === "1"
            },
            {
                title: "Surveillance Logs",
            content: 'Logs of users without permits, including their entry and exit images',
            targetClass: 'society_step-9',
            visible: sessionStorage.getItem('show_visitor_logs') === "1"
            },
            {
                title: "Controllers",
            content: 'Displays all installed controllers at the site, serving as the system brain, indicating their internet connectivity status.',
            targetClass: 'society_step-10',
            visible: sessionStorage.getItem('show_parking_controllers') === "1"
            },
            
            {
                title: "Currently Parked",
            content: 'In this section you can check all the Currently Parked Vehicles.',
            targetClass: 'society_step-16',
            visible: sessionStorage.getItem('show_currently_parked') === "1"
            },
            {
                title: "Reports",
            content: 'Allows the creation of custom reports with the option to schedule them for daily, weekly, or monthly email delivery.',
            targetClass: 'society_step-15',
            visible: sessionStorage.getItem('show_reports') === "1"
            },
            {
                title: "Resources",
            content: 'Encompasses all ParkSmart-provided resources, from user app installation to onboarding vehicles.',
            targetClass: 'society_step-11',
            visible: true
            },
            
            {
                title: "Occupancy",
            content: 'Displays floor-wise vehicle entry, exit, and overall floor occupancy.',
            targetClass: 'society_step-13',
            visible: sessionStorage.getItem('show_rfid') === "1" && sessionStorage.getItem('show_floor_occupancy') === "1"
            },
            
            ]
        },


         
    }
);

export const changeUser = (data) => {
    const token = sessionStorage.getItem("token");
    const olduser = sessionStorage.getItem("user_id");
    sessionStorage.clear();
    sessionStorage.setItem("old_user", olduser);
    sessionStorage.setItem("old_token", token);

    try {
        fetch(`${config.HOST_NAME}/crm/accessUser`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${token}`
            },
            body: JSON.stringify({ userId: data.id })
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json(); // Parse the response as JSON
        })
        .then(responseJson => {
            if (responseJson.success === true) { // Log the response data when success is true
                saveDateToSessionNew(responseJson);
                window.location.replace(window.location.pathname);
            } else {
                notify(`API request was not successful: ${data}`, "error");
            }
        })
        .catch(error => {
            console.error('Fetch error:', error);
        });
    } catch (error) {
        console.error('Try-catch error:', error);
    }
}

export const changeToOldUser = () => {
    const old_token = sessionStorage.getItem("old_token");
    const userId = sessionStorage.getItem("old_user");
    sessionStorage.clear();
    

    try {
        fetch(`${config.HOST_NAME}/crm/accessUser`, {
            method: 'POST',
            headers: {
                'Content-Type': 'application/json',
                'Authorization': `Bearer ${old_token}`
            },
            body: JSON.stringify({userId :  parseInt(userId, 10)})
        })
        .then(response => {
            if (!response.ok) {
                throw new Error(`HTTP error! Status: ${response.status}`);
            }
            return response.json(); // Parse the response as JSON
        })
        .then(responseJson => {
            if (responseJson.success === true) { // Log the response data when success is true
                sessionStorage.removeItem("old_user");
                saveDateToSessionOld(responseJson);
                window.location.replace(window.location.pathname);
            } else {
                notify(`API request was not successful`, "error");
            }
        })
        .catch(error => {
            console.error('Fetch error:', error);
        });
    } catch (error) {
        console.error('Try-catch error:', error);
    }
}

const saveDateToSessionOld = (responseJson) => {
    sessionStorage.setItem('user_id', responseJson.data.id);
    sessionStorage.setItem('username', responseJson.data.username);
    sessionStorage.setItem("summary_start_time",responseJson.data.summary_start_time);
    sessionStorage.setItem("disable_downloads", responseJson.data.disable_downloads);
    sessionStorage.setItem('token', responseJson.data.token);
    sessionStorage.setItem('refresh_token', responseJson.data.refresh_token);
    sessionStorage.setItem('role', responseJson.data.role);
    sessionStorage.setItem('display_name', responseJson.data.display_name);
    sessionStorage.setItem('full_name', responseJson.data.full_name);
    sessionStorage.setItem('email', responseJson.data.email);
    sessionStorage.setItem('mobile', responseJson.data.mobile);
    sessionStorage.setItem('show_monthly_pass', responseJson.data.show_monthly_pass);
    sessionStorage.setItem('allow_edit_monthly_pass', responseJson.data.allow_edit_monthly_pass);
    sessionStorage.setItem('show_dashboard_summary', responseJson.data.show_dashboard_summary);
    sessionStorage.setItem('show_avg_summary_amount', responseJson.data.show_avg_summary_amount);
    sessionStorage.setItem('show_time_till_seconds', responseJson.data.show_time_till_seconds);
    sessionStorage.setItem('use_24_hour_format', responseJson.data.use_24_hour_format);
    sessionStorage.setItem('allow_payment', responseJson.data.allow_payment);
    sessionStorage.setItem('allow_pass_recharge', responseJson.data.allow_pass_recharge);
    sessionStorage.setItem('allow_pass_delete', responseJson.data.allow_pass_delete);
    sessionStorage.setItem('show_rfid', responseJson.data.show_rfid);
    sessionStorage.setItem('show_rfid_requests', responseJson.data.show_rfid_requests);
    sessionStorage.setItem('show_rfid_company', responseJson.data.show_rfid_company);
    sessionStorage.setItem('show_rfid_inventory', responseJson.data.show_rfid_inventory);
    sessionStorage.setItem('allow_rfid_create', responseJson.data.allow_rfid_create);
    sessionStorage.setItem('allow_rfid_delete', responseJson.data.allow_rfid_delete);
    sessionStorage.setItem('show_rfid_column', responseJson.data.show_rfid_column);
    sessionStorage.setItem('show_tag_column', responseJson.data.show_tag_column);
    sessionStorage.setItem('show_flat_details', responseJson.data.show_flat_details);
    sessionStorage.setItem('show_validity_column', responseJson.data.show_validity_column);
    sessionStorage.setItem('show_rfid_payments', responseJson.data.show_rfid_payments);
    sessionStorage.setItem('allow_unallocated_rfid', responseJson.data.allow_unallocated_rfid);
    sessionStorage.setItem('show_vaccine_drive', responseJson.data.show_vaccine_drive);
    sessionStorage.setItem('allow_current_vehicles_update', responseJson.data.allow_current_vehicles_update);
    sessionStorage.setItem('view_only', responseJson.data.view_only);
    sessionStorage.setItem('hide_parking_section', responseJson.data.hide_parking_section);
    sessionStorage.setItem('hide_parking_led', responseJson.data.hide_parking_led);
    sessionStorage.setItem('hide_operator_users', responseJson.data.hide_operator_users);
    sessionStorage.setItem('hide_device_issues', responseJson.data.hide_device_issues);
    sessionStorage.setItem('allow_admin_creation', responseJson.data.allow_admin_creation);
    sessionStorage.setItem('hide_parking_details', responseJson.data.hide_parking_details);
    sessionStorage.setItem('hide_vehicle_database', responseJson.data.hide_vehicle_database);
    sessionStorage.setItem('company_user', responseJson.data.company_user);
    sessionStorage.setItem('allow_company_user_create', responseJson.data.allow_company_user_create);
    sessionStorage.setItem('show_operator', responseJson.data.show_operator);
    sessionStorage.setItem('allow_fastag', responseJson.data.allow_fastag);
    sessionStorage.setItem('rfid_validity_default', responseJson.data.rfid_validity_default);
    sessionStorage.setItem('show_inventory', responseJson.data.show_inventory);
    sessionStorage.setItem('show_filter', responseJson.data.show_filter);
    sessionStorage.setItem('show_verify_vehicle', responseJson.data.show_verify_vehicle);
    sessionStorage.setItem('show_parking_slot_booking', responseJson.data.show_parking_slot_bookings);
    sessionStorage.setItem('show_parking_controllers', responseJson.data.show_parking_controllers);
    sessionStorage.setItem('show_rfid_recharge', responseJson.data.show_rfid_recharge);
    sessionStorage.setItem('show_monthlypass_request', responseJson.data.show_monthlypass_request);
    sessionStorage.setItem('show_permit_apartments', responseJson.data.show_permit_apartments);
    sessionStorage.setItem('show_device_wallet', responseJson.data.show_device_wallet);
    sessionStorage.setItem('filter_category', responseJson.data.filter_category);
    sessionStorage.setItem('show_paid_unpaid_amount', responseJson.data.show_paid_unpaid_amount);
    sessionStorage.setItem('show_monthly_pass_log', responseJson.data.show_monthly_pass_log);
    sessionStorage.setItem('show_fastag_payment', responseJson.data.show_fastag_payment);
    sessionStorage.setItem('data_period_allowed', responseJson.data.data_period_allowed);
    sessionStorage.setItem('all_parkings_details', responseJson.data.all_parkings_details);
    sessionStorage.setItem('create_permit_name_required', responseJson.data.create_permit_name_required);
    sessionStorage.setItem('show_exempted_vehicles', responseJson.data.show_exempted_vehicles);
    sessionStorage.setItem('show_resources_separately', responseJson.data.show_resources_separately);
    sessionStorage.setItem('show_profile', responseJson.data.show_profile);
    sessionStorage.setItem('show_anpr_images', responseJson.data.show_anpr_images);
    sessionStorage.setItem('show_visitor_logs', responseJson.data.show_visitor_logs);
    sessionStorage.setItem('hide_mobile_number', responseJson.data.hide_mobile_number);
    sessionStorage.setItem('show_reserved_column', responseJson.data.show_reserved_column);
    sessionStorage.setItem('show_exit_vehicle_button', responseJson.data.show_exit_vehicle_button);
    sessionStorage.setItem('show_ieems_section', responseJson.data.show_ieems_section);
    sessionStorage.setItem('show_rfid_logs', responseJson.data.show_rfid_logs);
    sessionStorage.setItem('show_company_column', responseJson.data.show_company_column);
    sessionStorage.setItem('show_permits', responseJson.data.show_permits);
    sessionStorage.setItem('show_clients_info', responseJson.data.show_clients_info);
    sessionStorage.setItem('show_dashboard_users', responseJson.data.show_dashboard_users);
    sessionStorage.setItem('show_card_inventory', responseJson.data.show_card_inventory);
    sessionStorage.setItem('show_rfid_deleted_details', responseJson.data.show_rfid_deleted_details);
    sessionStorage.setItem('show_site_audits', responseJson.data.show_site_audits);
    sessionStorage.setItem('show_warrior_users', responseJson.data.show_warrior_users);
    sessionStorage.setItem('show_map_view', responseJson.data.show_map_view);
    sessionStorage.setItem('show_device_issues', responseJson.data.show_device_issues);
    sessionStorage.setItem('show_parking_details', responseJson.data.show_parking_details);
    sessionStorage.setItem('show_dashboard_logs', responseJson.data.show_dashboard_logs);
    sessionStorage.setItem('show_fastag_api_data', responseJson.data.show_fastag_api_data);
    sessionStorage.setItem('show_onboard_users', responseJson.data.show_onboard_users);
    sessionStorage.setItem('show_parking_terminals', responseJson.data.show_parking_terminals);
    sessionStorage.setItem('allow_parking_led_settings', responseJson.data.allow_parking_led_settings);
    sessionStorage.setItem('allow_parking_info_edit', responseJson.data.allow_parking_info_edit);
    sessionStorage.setItem('allow_parking_license_update', responseJson.data.allow_parking_license_update);
    sessionStorage.setItem('allow_parking_status_toggle', responseJson.data.allow_parking_status_toggle);
    sessionStorage.setItem('allow_create_parking', responseJson.data.allow_create_parking);
    sessionStorage.setItem('allow_download_parkings', responseJson.data.allow_download_parkings);
    sessionStorage.setItem('allow_update_parking', responseJson.data.allow_update_parking);
    sessionStorage.setItem('allow_terminal_edit', responseJson.data.allow_terminal_edit);
    sessionStorage.setItem('allow_delete_terminal', responseJson.data.allow_delete_terminal);
    sessionStorage.setItem('show_parking_analytics', responseJson.data.show_parking_analytics);
    sessionStorage.setItem('create_without_terminal', responseJson.data.create_without_terminal);
    sessionStorage.setItem('allow_terminal_device_changes', responseJson.data.allow_terminal_device_changes);
    sessionStorage.setItem('payment_distributions', responseJson.data.payment_distributions);
    sessionStorage.setItem('show_purchased_fastag', responseJson.data.show_purchased_fastag);
    sessionStorage.setItem('show_cameras', responseJson.data.show_cameras);
    sessionStorage.setItem('create_permit_without_mobile', responseJson.data.create_permit_without_mobile);
    sessionStorage.setItem('separate_summary_of_devices', responseJson.data.separate_summary_of_devices);
    sessionStorage.setItem('limit_data_range', responseJson.data.limit_data_range);
    sessionStorage.setItem('show_surveillance_images', responseJson.data.show_surveillance_images);
    sessionStorage.setItem('use_latest_version', responseJson.data.use_latest_version);
    sessionStorage.setItem('redirect_after_login', responseJson.data.redirect_after_login);
    sessionStorage.setItem('show_anpr_raw_image', responseJson.data.show_anpr_raw_image);
    sessionStorage.setItem('reduce_summary', responseJson.data.reduce_summary);
    sessionStorage.setItem('make_exit_free', responseJson.data.make_exit_free);
    sessionStorage.setItem('show_reports', responseJson.data.show_reports);
    sessionStorage.setItem('show_patrolling', responseJson.data.show_patrolling);
    sessionStorage.setItem('vehicle_summary_name', responseJson.data.vehicle_summary_name);
    sessionStorage.setItem('separate_entry_exit_images', responseJson.data.separate_entry_exit_images);
    sessionStorage.setItem('check_vehicle_exit', responseJson.data.check_vehicle_exit);
    sessionStorage.setItem('demo_access', responseJson.data.demo_access);
    sessionStorage.setItem('create_sub_user', responseJson.data.create_sub_user);
    sessionStorage.setItem('show_qr_transactions', responseJson.data.show_qr_transactions);
    sessionStorage.setItem('society_onboard_tour', responseJson.data.society_onboard_tour);
    sessionStorage.setItem('show_anpr_options', responseJson.data.show_anpr_options);
    sessionStorage.setItem('show_ramp_entry', responseJson.data.show_ramp_entry);
    sessionStorage.setItem('vehicle_types', responseJson.data.vehicle_types);
    sessionStorage.setItem('show_floor_occupancy', responseJson.data.show_floor_occupancy);
    sessionStorage.setItem('vehicle_summary_mask', responseJson.data.vehicle_summary_mask);
    sessionStorage.setItem('show_currently_parked', responseJson.data.show_currently_parked);
    sessionStorage.setItem('show_settlements', responseJson.data.show_settlements);
    sessionStorage.setItem('edit_device_limit', responseJson.data.edit_device_limit);
    sessionStorage.setItem('slot_name_required', responseJson.data.slot_name_required);
    sessionStorage.setItem('restrict_permits', responseJson.data.restrict_permits);
    sessionStorage.setItem('show_filter', responseJson.data.show_filter ? responseJson.data.show_filter : 1);
    sessionStorage.setItem('hide_summary_search', responseJson.data.hide_summary_search);
    sessionStorage.setItem('show_barrier_activity', responseJson.data.show_barrier_activity);
    sessionStorage.setItem('show_pucc_validity', responseJson.data.show_pucc_validity);
    sessionStorage.setItem('show_dashboard_insights', responseJson.data.show_dashboard_insights);
    sessionStorage.setItem('hide_date_wise_filter', responseJson.data.hide_date_wise_filter);
    sessionStorage.setItem('hide_monthly_wise_date_filter', responseJson.data.hide_monthly_wise_date_filter);
    sessionStorage.setItem('hide_custom_date_filter', responseJson.data.hide_custom_date_filter);
    sessionStorage.setItem('hide_time_filter', responseJson.data.hide_time_filter);
    sessionStorage.setItem('date_till_yesterday', responseJson.data.date_till_yesterday);
    sessionStorage.setItem('show_valet_bookings', responseJson.data.show_valet_bookings);
    sessionStorage.setItem('show_missed_visitors', responseJson.data.show_missed_visitors);
    sessionStorage.setItem('show_apartment_as_unit', responseJson.data.show_apartment_as_unit);
    sessionStorage.setItem('show_qr_codes', responseJson.data.show_qr_codes);
    sessionStorage.setItem('hide_contact_us', responseJson.data.hide_contact_us);
    sessionStorage.setItem('hide_resources', responseJson.data.hide_resources);
    sessionStorage.setItem('only_allow_day_permit', responseJson.data.only_allow_day_permit);
    sessionStorage.setItem('show_permit_validity_toggle', responseJson.data.show_permit_validity_toggle);
    sessionStorage.setItem('hide_permit_amount_details', responseJson.data.hide_permit_amount_details);
    sessionStorage.setItem('default_min_confidence', responseJson.data.default_min_confidence);
    sessionStorage.setItem('show_billing_invocies', responseJson.data.show_billing_invocies);
    sessionStorage.setItem('show_invoices_user_permits', responseJson.data.show_invoices_user_permits);
    sessionStorage.setItem('show_invoices_vaahan_api', responseJson.data.show_invoices_vaahan_api);
    sessionStorage.setItem('show_bulk_user', responseJson.data.show_bulk_user);
    sessionStorage.setItem('allow_add_inventory_tags', responseJson.data.allow_add_inventory_tags);
    sessionStorage.setItem('hide_permit_user_bulk_action', responseJson.data.hide_permit_user_bulk_action);
    sessionStorage.setItem('hide_permit_users_filter', responseJson.data.hide_permit_users_filter);
    sessionStorage.setItem('show_tutorial', responseJson.data.show_tutorial);
    sessionStorage.setItem('hide_change_password', responseJson.data.hide_change_password);
    sessionStorage.setItem('only_show_vehicle_search', responseJson.data.only_show_vehicle_search);
    sessionStorage.setItem('hide_unnecessary_permit_users_column', responseJson.data.hide_unnecessary_permit_users_column);
    sessionStorage.setItem('show_vehicle_not_registered_msg', responseJson.data.show_vehicle_not_registered_msg);
    sessionStorage.setItem('show_permit_defaulter', responseJson.data.show_permit_defaulter);
    sessionStorage.setItem('show_grace_period', responseJson.data.show_grace_period);
    sessionStorage.setItem('show_grace_period_logs', responseJson.data.show_grace_period_logs);
    sessionStorage.setItem('show_grace_period_configurations', responseJson.data.show_grace_period_configurations);
    sessionStorage.setItem('allow_visitor_delete', responseJson.data.allow_visitor_delete);
    sessionStorage.setItem('auto_refresh_vehicle_summary', responseJson.data.auto_refresh_vehicle_summary);
    sessionStorage.setItem('auto_refresh_vehicle_summary_enabled', responseJson.data.auto_refresh_vehicle_summary);
    sessionStorage.setItem('inactivity_limit_seconds', responseJson.data.inactivity_limit_seconds);
    sessionStorage.setItem('show_operator_devices', responseJson.data.show_operator_devices);
    sessionStorage.setItem('show_operator_shifts', responseJson.data.show_operator_shifts);
    sessionStorage.setItem('show_operator_users', responseJson.data.show_operator_users);
    sessionStorage.setItem('hide_parking_column', responseJson.data.hide_parking_column);
    sessionStorage.setItem('show_inventory_home', responseJson.data.show_inventory_home);
}

const saveDateToSessionNew = (responseJson) => {
    sessionStorage.setItem('user_id', responseJson.data.id);
    sessionStorage.setItem('username', responseJson.data.username);
    sessionStorage.setItem(
        "summary_start_time",
        responseJson.data.summary_start_time
    );
    sessionStorage.setItem("disable_downloads", responseJson.data.disable_downloads);
    sessionStorage.setItem('token', responseJson.data.token);
    sessionStorage.setItem('refresh_token', responseJson.data.refresh_token);
    sessionStorage.setItem('role', responseJson.data.role);
    sessionStorage.setItem('display_name', responseJson.data.display_name);
    sessionStorage.setItem('full_name', responseJson.data.full_name);
    sessionStorage.setItem('email', responseJson.data.email);
    sessionStorage.setItem('mobile', responseJson.data.mobile);
    sessionStorage.setItem('show_monthly_pass', responseJson.data.show_monthly_pass);
    sessionStorage.setItem('allow_edit_monthly_pass', responseJson.data.allow_edit_monthly_pass);
    sessionStorage.setItem('show_dashboard_summary', responseJson.data.show_dashboard_summary);
    sessionStorage.setItem('show_avg_summary_amount', responseJson.data.show_avg_summary_amount);
    sessionStorage.setItem('show_time_till_seconds', responseJson.data.show_time_till_seconds);
    sessionStorage.setItem('use_24_hour_format', responseJson.data.use_24_hour_format);
    sessionStorage.setItem('allow_payment', responseJson.data.allow_payment);
    sessionStorage.setItem('allow_pass_recharge', responseJson.data.allow_pass_recharge);
    sessionStorage.setItem('allow_pass_delete', responseJson.data.allow_pass_delete);
    sessionStorage.setItem('show_rfid', responseJson.data.show_rfid);
    sessionStorage.setItem('show_rfid_requests', responseJson.data.show_rfid_requests);
    sessionStorage.setItem('show_rfid_company', responseJson.data.show_rfid_company);
    sessionStorage.setItem('show_rfid_inventory', responseJson.data.show_rfid_inventory);
    sessionStorage.setItem('allow_rfid_create', responseJson.data.allow_rfid_create);
    sessionStorage.setItem('allow_rfid_delete', responseJson.data.allow_rfid_delete);
    sessionStorage.setItem('show_rfid_column', responseJson.data.show_rfid_column);
    sessionStorage.setItem('show_tag_column', responseJson.data.show_tag_column);
    sessionStorage.setItem('show_flat_details', responseJson.data.show_flat_details);
    sessionStorage.setItem('show_validity_column', responseJson.data.show_validity_column);
    sessionStorage.setItem('show_rfid_payments', responseJson.data.show_rfid_payments);
    sessionStorage.setItem('allow_unallocated_rfid', responseJson.data.allow_unallocated_rfid);
    sessionStorage.setItem('show_vaccine_drive', responseJson.data.show_vaccine_drive);
    sessionStorage.setItem('allow_current_vehicles_update', responseJson.data.allow_current_vehicles_update);
    sessionStorage.setItem('view_only', responseJson.data.view_only);
    sessionStorage.setItem('hide_parking_section', responseJson.data.hide_parking_section);
    sessionStorage.setItem('hide_parking_led', responseJson.data.hide_parking_led);
    sessionStorage.setItem('hide_operator_users', responseJson.data.hide_operator_users);
    sessionStorage.setItem('hide_device_issues', responseJson.data.hide_device_issues);
    sessionStorage.setItem('allow_admin_creation', responseJson.data.allow_admin_creation);
    sessionStorage.setItem('hide_parking_details', responseJson.data.hide_parking_details);
    sessionStorage.setItem('hide_vehicle_database', responseJson.data.hide_vehicle_database);
    sessionStorage.setItem('company_user', responseJson.data.company_user);
    sessionStorage.setItem('allow_company_user_create', responseJson.data.allow_company_user_create);
    sessionStorage.setItem('show_operator', responseJson.data.show_operator);
    sessionStorage.setItem('allow_fastag', responseJson.data.allow_fastag);
    sessionStorage.setItem('rfid_validity_default', responseJson.data.rfid_validity_default);
    sessionStorage.setItem('show_inventory', responseJson.data.show_inventory);
    sessionStorage.setItem('show_filter', responseJson.data.show_filter);
    sessionStorage.setItem('show_verify_vehicle', responseJson.data.show_verify_vehicle);
    sessionStorage.setItem('show_parking_slot_booking', responseJson.data.show_parking_slot_bookings);
    sessionStorage.setItem('show_parking_controllers', responseJson.data.show_parking_controllers);
    sessionStorage.setItem('show_rfid_recharge', responseJson.data.show_rfid_recharge);
    sessionStorage.setItem('show_monthlypass_request', responseJson.data.show_monthlypass_request);
    sessionStorage.setItem('show_permit_apartments', responseJson.data.show_permit_apartments);
    sessionStorage.setItem('show_device_wallet', responseJson.data.show_device_wallet);
    sessionStorage.setItem('filter_category', responseJson.data.filter_category);
    sessionStorage.setItem('show_paid_unpaid_amount', responseJson.data.show_paid_unpaid_amount);
    sessionStorage.setItem('show_monthly_pass_log', responseJson.data.show_monthly_pass_log);
    sessionStorage.setItem('show_fastag_payment', responseJson.data.show_fastag_payment);
    sessionStorage.setItem('data_period_allowed', responseJson.data.data_period_allowed);
    sessionStorage.setItem('all_parkings_details', responseJson.data.all_parkings_details);
    sessionStorage.setItem('create_permit_name_required', responseJson.data.create_permit_name_required);
    sessionStorage.setItem('show_exempted_vehicles', responseJson.data.show_exempted_vehicles);
    sessionStorage.setItem('show_resources_separately', responseJson.data.show_resources_separately);
    sessionStorage.setItem('show_profile', responseJson.data.show_profile);
    sessionStorage.setItem('show_anpr_images', responseJson.data.show_anpr_images);
    sessionStorage.setItem('show_visitor_logs', responseJson.data.show_visitor_logs);
    sessionStorage.setItem('hide_mobile_number', responseJson.data.hide_mobile_number);
    sessionStorage.setItem('show_reserved_column', responseJson.data.show_reserved_column);
    sessionStorage.setItem('show_exit_vehicle_button', responseJson.data.show_exit_vehicle_button);
    sessionStorage.setItem('show_ieems_section', responseJson.data.show_ieems_section);
    sessionStorage.setItem('show_rfid_logs', responseJson.data.show_rfid_logs);
    sessionStorage.setItem('show_company_column', responseJson.data.show_company_column);
    sessionStorage.setItem('show_permits', responseJson.data.show_permits);
    sessionStorage.setItem('show_clients_info', responseJson.data.show_clients_info);
    sessionStorage.setItem('show_dashboard_users', responseJson.data.show_dashboard_users);
    sessionStorage.setItem('show_card_inventory', responseJson.data.show_card_inventory);
    sessionStorage.setItem('show_rfid_deleted_details', responseJson.data.show_rfid_deleted_details);
    sessionStorage.setItem('show_site_audits', responseJson.data.show_site_audits);
    sessionStorage.setItem('show_warrior_users', responseJson.data.show_warrior_users);
    sessionStorage.setItem('show_map_view', responseJson.data.show_map_view);
    sessionStorage.setItem('show_device_issues', responseJson.data.show_device_issues);
    sessionStorage.setItem('show_parking_details', responseJson.data.show_parking_details);
    sessionStorage.setItem('show_dashboard_logs', responseJson.data.show_dashboard_logs);
    sessionStorage.setItem('show_fastag_api_data', responseJson.data.show_fastag_api_data);
    sessionStorage.setItem('show_onboard_users', responseJson.data.show_onboard_users);
    sessionStorage.setItem('show_parking_terminals', responseJson.data.show_parking_terminals);
    sessionStorage.setItem('allow_parking_led_settings', responseJson.data.allow_parking_led_settings);
    sessionStorage.setItem('allow_parking_info_edit', responseJson.data.allow_parking_info_edit);
    sessionStorage.setItem('allow_parking_license_update', responseJson.data.allow_parking_license_update);
    sessionStorage.setItem('allow_parking_status_toggle', responseJson.data.allow_parking_status_toggle);
    sessionStorage.setItem('allow_create_parking', responseJson.data.allow_create_parking);
    sessionStorage.setItem('allow_download_parkings', responseJson.data.allow_download_parkings);
    sessionStorage.setItem('allow_update_parking', responseJson.data.allow_update_parking);
    sessionStorage.setItem('allow_terminal_edit', responseJson.data.allow_terminal_edit);
    sessionStorage.setItem('allow_delete_terminal', responseJson.data.allow_delete_terminal);
    sessionStorage.setItem('show_parking_analytics', responseJson.data.show_parking_analytics);
    sessionStorage.setItem('create_without_terminal', responseJson.data.create_without_terminal);
    sessionStorage.setItem('allow_terminal_device_changes', responseJson.data.allow_terminal_device_changes);
    sessionStorage.setItem('payment_distributions', responseJson.data.payment_distributions);
    sessionStorage.setItem('show_purchased_fastag', responseJson.data.show_purchased_fastag);
    sessionStorage.setItem('show_cameras', responseJson.data.show_cameras);
    sessionStorage.setItem('create_permit_without_mobile', responseJson.data.create_permit_without_mobile);
    sessionStorage.setItem('separate_summary_of_devices', responseJson.data.separate_summary_of_devices);
    sessionStorage.setItem('limit_data_range', responseJson.data.limit_data_range);
    sessionStorage.setItem('show_surveillance_images', responseJson.data.show_surveillance_images);
    sessionStorage.setItem('use_latest_version', responseJson.data.use_latest_version);
    sessionStorage.setItem('redirect_after_login', responseJson.data.redirect_after_login);
    sessionStorage.setItem('show_anpr_raw_image', responseJson.data.show_anpr_raw_image);
    sessionStorage.setItem('reduce_summary', responseJson.data.reduce_summary);
    sessionStorage.setItem('make_exit_free', responseJson.data.make_exit_free);
    sessionStorage.setItem('show_reports', responseJson.data.show_reports);
    sessionStorage.setItem('show_patrolling', responseJson.data.show_patrolling);
    sessionStorage.setItem('vehicle_summary_name', responseJson.data.vehicle_summary_name);
    sessionStorage.setItem('separate_entry_exit_images', responseJson.data.separate_entry_exit_images);
    sessionStorage.setItem('check_vehicle_exit', responseJson.data.check_vehicle_exit);
    sessionStorage.setItem('demo_access', responseJson.data.demo_access);
    sessionStorage.setItem('create_sub_user', responseJson.data.create_sub_user);
    sessionStorage.setItem('show_qr_transactions', responseJson.data.show_qr_transactions);
    sessionStorage.setItem('society_onboard_tour', responseJson.data.society_onboard_tour);
    sessionStorage.setItem('show_anpr_options', responseJson.data.show_anpr_options);
    sessionStorage.setItem('show_ramp_entry', responseJson.data.show_ramp_entry);
    sessionStorage.setItem('vehicle_types', responseJson.data.vehicle_types);
    sessionStorage.setItem('show_floor_occupancy', responseJson.data.show_floor_occupancy);
    sessionStorage.setItem('vehicle_summary_mask', responseJson.data.vehicle_summary_mask);
    sessionStorage.setItem('show_currently_parked', responseJson.data.show_currently_parked);
    sessionStorage.setItem('show_settlements', responseJson.data.show_settlements);
    sessionStorage.setItem('edit_device_limit', responseJson.data.edit_device_limit);
    sessionStorage.setItem('slot_name_required', responseJson.data.slot_name_required);
    sessionStorage.setItem('restrict_permits', responseJson.data.restrict_permits);
    sessionStorage.setItem('show_filter', responseJson.data.show_filter);
    sessionStorage.setItem('hide_summary_search', responseJson.data.hide_summary_search);
    sessionStorage.setItem('show_barrier_activity', responseJson.data.show_barrier_activity);
    sessionStorage.setItem('show_pucc_validity', responseJson.data.show_pucc_validity);
    sessionStorage.setItem('show_dashboard_insights', responseJson.data.show_dashboard_insights);
    sessionStorage.setItem('hide_date_wise_filter', responseJson.data.hide_date_wise_filter);
    sessionStorage.setItem('hide_monthly_wise_date_filter', responseJson.data.hide_monthly_wise_date_filter);
    sessionStorage.setItem('hide_custom_date_filter', responseJson.data.hide_custom_date_filter);
    sessionStorage.setItem('hide_time_filter', responseJson.data.hide_time_filter);
    sessionStorage.setItem('date_till_yesterday', responseJson.data.date_till_yesterday);
    sessionStorage.setItem('show_valet_bookings', responseJson.data.show_valet_bookings);
    sessionStorage.setItem('show_missed_visitors', responseJson.data.show_missed_visitors);
    sessionStorage.setItem('show_apartment_as_unit', responseJson.data.show_apartment_as_unit);
    sessionStorage.setItem('show_qr_codes', responseJson.data.show_qr_codes);
    sessionStorage.setItem('hide_contact_us', responseJson.data.hide_contact_us);
    sessionStorage.setItem('hide_resources', responseJson.data.hide_resources);
    sessionStorage.setItem('only_allow_day_permit', responseJson.data.only_allow_day_permit);
    sessionStorage.setItem('show_permit_validity_toggle', responseJson.data.show_permit_validity_toggle);
    sessionStorage.setItem('hide_permit_amount_details', responseJson.data.hide_permit_amount_details);
    sessionStorage.setItem('default_min_confidence', responseJson.data.default_min_confidence);
    sessionStorage.setItem('show_billing_invocies', responseJson.data.show_billing_invocies);
    sessionStorage.setItem('show_invoices_user_permits', responseJson.data.show_invoices_user_permits);
    sessionStorage.setItem('show_invoices_vaahan_api', responseJson.data.show_invoices_vaahan_api);
    sessionStorage.setItem('show_bulk_user', responseJson.data.show_bulk_user);
    sessionStorage.setItem('allow_add_inventory_tags', responseJson.data.allow_add_inventory_tags);
    sessionStorage.setItem('hide_permit_user_bulk_action', responseJson.data.hide_permit_user_bulk_action);
    sessionStorage.setItem('hide_permit_users_filter', responseJson.data.hide_permit_users_filter);
    sessionStorage.setItem('show_tutorial', responseJson.data.show_tutorial);
    sessionStorage.setItem('hide_change_password', responseJson.data.hide_change_password);
    sessionStorage.setItem('only_show_vehicle_search', responseJson.data.only_show_vehicle_search);
    sessionStorage.setItem('hide_unnecessary_permit_users_column', responseJson.data.hide_unnecessary_permit_users_column);
    sessionStorage.setItem('show_vehicle_not_registered_msg', responseJson.data.show_vehicle_not_registered_msg);
    sessionStorage.setItem('show_permit_defaulter', responseJson.data.show_permit_defaulter);
    sessionStorage.setItem('show_grace_period', responseJson.data.show_grace_period);
    sessionStorage.setItem('show_grace_period_logs', responseJson.data.show_grace_period_logs);
    sessionStorage.setItem('show_grace_period_configurations', responseJson.data.show_grace_period_configurations);
    sessionStorage.setItem('allow_visitor_delete', responseJson.data.allow_visitor_delete);
    sessionStorage.setItem('auto_refresh_vehicle_summary', responseJson.data.auto_refresh_vehicle_summary);
    sessionStorage.setItem('auto_refresh_vehicle_summary_enabled', responseJson.data.auto_refresh_vehicle_summary);
    sessionStorage.setItem('inactivity_limit_seconds', responseJson.data.inactivity_limit_seconds);
    sessionStorage.setItem('show_operator_devices', responseJson.data.show_operator_devices);
    sessionStorage.setItem('show_operator_shifts', responseJson.data.show_operator_shifts);
    sessionStorage.setItem('show_operator_users', responseJson.data.show_operator_users);
    sessionStorage.setItem('hide_parking_column', responseJson.data.hide_parking_column);
    sessionStorage.setItem('show_inventory_home', responseJson.data.show_inventory_home);
}

export const changeToAdminUser = () => {
    sessionStorage.removeItem("clicked_user");
    window.location.replace(window.location.pathname);
}

export const ParkingsIncludeHelmetType = ["GIPBIKEVP", "GIPHELM", "GIPMANOIDA"]

export const discountPaymentModes = {
    "CASH": false,
    "CARD": false,
    "QR CODE": false,
    "ONLINE": false,
    "WALLET": false
}
